import Vue from 'vue';

Vue.mixin({
	methods: {
		openSupportForm () {
			document.getElementById('launcher-frame').contentWindow.document.getElementsByClassName('launcher-button')[0].click();
		}
	}
});
